module.exports = __webpack_public_path__ + "media/seher_1.1i.4b1f4d78.mp3";